const authRoutes = [
  {
    path: '/auth/wx-auth',
    name: 'wx-auth',
    component: () => import('@/views/auth/wx-auth'),
    meta: {
      title: '微信登录'
    }
  },
  {
    path: '/external/user/binding',
    name: 'externalBind',
    component: () => import('@/views/external/user/bind'),
    meta: {
      title: '验证授权'
    }
  },
  {
    path: '/external/user/auth',
    name: 'externalAuth',
    component: () => import('@/views/external/user/auth'),
    meta: {
      title: '验证授权'
    }
  },
  {
    path: '/external/user/request-login',
    name: 'requestLogin',
    component: () => import('@/views/external/user/request-login'),
    meta: {
      title: '验证授权'
    }
  }
]

export default authRoutes
